import { z } from 'zod';

// Wire contract for crediting a user's balance DO across a worker boundary
// (ton-watcher → UserBalanceDO via stub.fetch). The DO's debit/getBalance are
// invoked as typed RPC from within the api/lot-do worker, but credit crosses a
// script boundary where wrangler cannot type cross-script DO RPC, so it goes
// over fetch with this schema validated on both ends.

export const USER_BALANCE_CREDIT_PATH = '/credit';

export const userBalanceCreditRequestSchema = z.object({
  userId: z.number().int().positive(),
  amount: z.number().int().positive(),
  idemKey: z.string().min(1).max(128),
  reason: z.string().min(1).max(32),
  note: z.string().max(128).optional(),
});

export type UserBalanceCreditRequest = z.infer<typeof userBalanceCreditRequestSchema>;

export const userBalanceCreditResponseSchema = z.object({
  ok: z.literal(true),
  balanceAfter: z.number().int().nonnegative(),
});

export type UserBalanceCreditResponse = z.infer<typeof userBalanceCreditResponseSchema>;
